"use client";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { normalizeReferralCode } from "@portal/shared/referral";
import { useEffect, useState } from "react";
import { Checkbox } from "../../../components/fields";
import { Button, Page, Section, SectionBody, Status, styles as s } from "../../../components/ui";

export const CONSENT_KEY = "mp_register_consent";
/** 勧誘コード（機能仕様1.12）。登録が終わるまでこのブラウザで持つ */
export const REF_KEY = "mp_register_ref";
/** お客さまごとの QR の利用者コード（入力欄に入れておくだけ。鍵ではない, 機能仕様5.1.3） */
export const CODE_KEY = "mp_register_code";

export function ConsentStep({ viaLine, refCode, customerCode, html, draft, lineEnabled = false }: { viaLine: boolean; refCode: string | null; customerCode?: string | null; html: string; draft: boolean; lineEnabled?: boolean }) {
  const router = useRouter();
  const [agree, setAgree] = useState(false);
  useEffect(() => {
    const code = normalizeReferralCode(refCode);
    if (code) try { sessionStorage.setItem(REF_KEY, code); } catch {}
  }, [refCode]);
  useEffect(() => {
    const code = customerCode?.replace(/[^0-9０-９]/g, "").slice(0, 20);
    if (code) try { sessionStorage.setItem(CODE_KEY, code); } catch {}
  }, [customerCode]);
  const next = () => {
    try { sessionStorage.setItem(CONSENT_KEY, new Date().toISOString()); } catch {}
    router.push(viaLine ? "/register/form?via=line" : "/register/form");
  };
  return (
    <Page title="電子で受け取ることへの同意" lead={`マイページに登録すると、ご請求書・領収書を郵送ではなく、このマイページでお届けし、ショートメール${lineEnabled ? "（または LINE）" : ""}でお知らせします。内容をお読みのうえ、同意してください。`}>
      <p className={s.steps}>新規登録　手順 1 / {viaLine ? 2 : 3}</p>
      {draft && <Status tone="warn">この文面は下書きです（公開前に確定します）。</Status>}
      <Section title="ご確認ください">
        <SectionBody>
          {/* biome-ignore lint/security/noDangerouslySetInnerHtml: 社内で管理する文面 */}
          <div className={s.prose} dangerouslySetInnerHTML={{ __html: html }} />
          <p>
            あわせて <Link href="/terms" target="_blank">利用規約</Link>・<Link href="/privacy" target="_blank">個人情報保護方針</Link> もご覧ください。
          </p>
        </SectionBody>
      </Section>
      <Checkbox label="内容を読み、電子で受け取ることに同意します" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
      <Button variant="primary" block disabled={!agree} onClick={next}>同意して次へ</Button>
    </Page>
  );
}
